import { FC, useState } from 'react';
import { FormControl, Select, MenuItem, FormHelperText, InputAdornment, IconButton } from '@mui/material';
import { IUndefinedPart, IPart, IOrderDetailPart } from '../../../models';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Add } from '@mui/icons-material';
import { UndefinedPartsModal } from '../place-order/undefined-parts-modal';
import { Button } from '../../../components';

interface IPartNameRow {
  part: IPart | IOrderDetailPart;
  id: number;
  handlePartNameChange?: (val: number) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  isLoading: boolean;
  undefinedParts: IUndefinedPart[];
  updateOptions: (callback: any) => void;
}

export const PartNameRow: FC<IPartNameRow> = ({ part, id, handlePartNameChange, isDisabled = false, isRequired = true, undefinedParts, isLoading, updateOptions }) => {
  const classes = useStyles();

  const [showUndefinedPartsModal, setShowUndefinedPartsModal] = useState<boolean>(false);

  return (
    <>
      <FormControl fullWidth={undefinedParts.length < 1 && !isLoading ? false : true} variant="outlined" size="small" error={!part.undefinedPartDescriptionId}>
        {undefinedParts.length < 1 && !isLoading ? (
          <Button
            id={`add-undefined-part-description-${id}`}
            type="button"
            color="primary"
            variant="contained"
            startIcon={<Add />}
            onClick={() => setShowUndefinedPartsModal(true)}
          >
            Add Undefined Part Description
          </Button>
        ) : (
          <Select
            disabled={isLoading || isDisabled}
            name={`undefinedPart-${id}`}
            labelId={`undefinedPart-${id}`}
            id={`undefinedPart-${id}`}
            required={isRequired}
            value={part.undefinedPartDescriptionId || ''}
            error={!part.undefinedPartDescriptionId}
            className={classes.inputGroup}
            onChange={e => {
              const selectedUndefinedPart = undefinedParts.find(part => part.undefinedPartDescriptionId === Number(e.target.value));
              if (selectedUndefinedPart) {
                handlePartNameChange(selectedUndefinedPart.undefinedPartDescriptionId);
              }
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  id={`add-undefined-part-description-${id}`}
                  title="Add Undefined Part Description"
                  onClick={() => setShowUndefinedPartsModal(true)}
                  edge="end"
                  color="primary"
                >
                  <Add />
                </IconButton>
              </InputAdornment>
            }
          >
            {undefinedParts &&
              undefinedParts.map((part, index) => {
                return (
                  <MenuItem key={`${index}`} value={part.undefinedPartDescriptionId}>
                    {part.description}
                  </MenuItem>
                );
              })}
          </Select>
        )}
        {!part.undefinedPartDescriptionId && isRequired && undefinedParts.length > 0 && !isLoading && (
          <FormHelperText sx={{ lineHeight: 'initial', marginTop: '-30px', fontSize: '0.85rem', marginBottom: 'revert' }}>Required</FormHelperText>
        )}
        {undefinedParts.length < 1 && !isLoading && (
          <FormHelperText sx={{ lineHeight: 'initial', marginLeft: '0', fontSize: '0.85rem', marginBottom: 'revert' }}>Required</FormHelperText>
        )}
      </FormControl>
      <UndefinedPartsModal
        open={showUndefinedPartsModal}
        onClose={() => {
          setShowUndefinedPartsModal(false);
        }}
        onSave={(val: number) => {
          updateOptions(() => {
            handlePartNameChange(val);
          });
        }}
      />
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  optionInactive: {
    opacity: 0.38
  },
  inputGroup: {
    '&.MuiInputBase-adornedEnd .MuiSelect-icon, &.MuiInputBase-adornedEnd .MuiSelect-iconOpen': {
      right: theme.spacing(3)
    }
  }
}));
